<template>
  <div>
    <div class="tabs" id="tab_header" ref="tab_header">
      <ul>
        <li @click="selected = 1" :class="{'is-active' :selected == 1}"><a>Logged</a></li>
        <li @click="selected = 2" :class="{'is-active' :selected == 2}"><a>History/Archived</a></li>
      </ul>
    </div>
    <div class="box" id="tab_container" ref="tab_container">
      <div class="container_item" :class="{ 'is-active': selected == 1 }">
        <staff-time-log-logged />
      </div>
      <div class="container_item" :class="{'is-active' :selected == 2 }">
        <staff-time-log-history />
      </div>
    </div>
  </div>
</template>
<style>
  .tabs ul {
    align-items: baseline !important;
  }
  #tab_container .container_item {
    display: none;
  }
  #tab_container .container_item.is-active {
    display: block;
  }
</style>
<script>
import StaffTimeLogLogged from './LoggedTab.vue'
import StaffTimeLogHistory from './HistoryTab.vue'

export default {
  components: {
    StaffTimeLogLogged,
    StaffTimeLogHistory
  },
  data () {
    return {
      selected: 1
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/StaffTimeLog/StaffTimeLogPage.vue